import { useEffect, useState } from 'react';

const COLLAPSED_KEY = 'sysadmin-content-rail-collapsed';
// The legacy layout already knows how to shrink the left column for a collapsed nav.
const COLLAPSED_BODY_CLASS = 'left-nav-collapsed';

const readCollapsed = () => {
  try {
    return window.localStorage.getItem(COLLAPSED_KEY) === 'true';
  } catch {
    return false;
  }
};

// Collapsed state for a legacy-mounted rail: remembered per browser, mirrored onto <body> so the
// layout narrows the rail's column with it.
const useCollapsedRail = () => {
  const [collapsed, setCollapsed] = useState(readCollapsed);

  useEffect(() => {
    document.body.classList.toggle(COLLAPSED_BODY_CLASS, collapsed);
    try {
      window.localStorage.setItem(COLLAPSED_KEY, String(collapsed));
    } catch {
      // Storage unavailable; the rail still works, it just won't remember.
    }
    return () => document.body.classList.remove(COLLAPSED_BODY_CLASS);
  }, [collapsed]);

  return [collapsed, setCollapsed] as const;
};

export default useCollapsedRail;
